import { render, staticRenderFns } from "./DuplicateProjectModal.vue?vue&type=template&id=edbe5922&"
import script from "./DuplicateProjectModal.vue?vue&type=script&lang=ts&"
export * from "./DuplicateProjectModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports